export const teamMembers = [
  {
    id: 1,
    name: "Rajesh Menon",
    role: "Founder & CEO",
    bio: "Visionary leader with 20+ years in AV integration. Built Fiber One from a 3-person startup to a regional powerhouse across 4 countries.",
    initial: "R",
  },
  {
    id: 2,
    name: "Li Wei Chen",
    role: "Chief Technology Officer",
    bio: "Former lead engineer at a global display manufacturer. Drives Fiber One's innovation pipeline and proprietary AI platform.",
    initial: "L",
  },
  {
    id: 3,
    name: "Priya Narayanan",
    role: "Head of Operations",
    bio: "Expert in large-scale deployment logistics. Manages 200+ concurrent projects annually with a 98% on-time delivery rate.",
    initial: "P",
  },
  {
    id: 4,
    name: "Markus Tan",
    role: "Director of Sales",
    bio: "Specializes in enterprise and government sector partnerships. Expanded Fiber One's client base from 12 to over 500 organizations.",
    initial: "M",
  },
];

export const companyTimeline = [
  {
    year: "2013",
    title: "Formation of Fiber One",
    description: "",
    position: "top",
  },
  {
    year: "2014",
    title: "Million dollar revenue in 1st year of Operation",
    description: "",
    position: "bottom",
  },
  {
    year: "2015",
    title: "Expansion of company",
    description: "Moved into new office",
    position: "top",
  },
  {
    year: "2016",
    title: "2.5 million dollar in revenue",
    description: "",
    position: "bottom",
  },
  {
    year: "2017",
    title: "More main contractors",
    description: "M-moser Associates & DBB",
    position: "top",
  },
  {
    year: "2018",
    title: "5 million dollar in revenue",
    description: "",
    position: "bottom",
  },
  {
    year: "2019",
    title: "Started doing Government projects",
    description: "",
    position: "top",
  },
  {
    year: "2020",
    title: "Covid hit",
    description: "4.5 million in revenue, providing essential services",
    position: "bottom",
  },
  {
    year: "2021",
    title: "Recovery from covid",
    description: "More government projects, PUB, SLA",
    position: "top",
  },
  {
    year: "2022",
    title: "8 million dollars in revenue",
    description: "More government projects",
    position: "bottom",
  },
  {
    year: "2023",
    title: "Became Incumbent AV SI for VISA Singapore",
    description: "HIT 9 million dollars in revenue",
    position: "top",
  },
  {
    year: "2024",
    title: "Won Prudential project worth 2 million dollars",
    description: "",
    position: "bottom",
  },
  {
    year: "2025",
    title: "Became Starhub's AV Vendor",
    description: "Built AI Solutions, Launch of Fiber One Guard",
    position: "top",
  },
];

export const certifications = [
  {
    name: "AVIXA",
    description: "Global trade association dedicated to upholding excellence in the professional audiovisual industry.",
    image: "https://readdy.ai/api/search-image?query=Orange%20and%20red%20geometric%20triangle%20logo%20badge%20on%20white%20background%2C%20professional%20AV%20industry%20certification%20mark%2C%20clean%20minimal%20design%2C%20modern%20corporate%20style&width=200&height=80&seq=cert-avixa-01&orientation=landscape",
  },
  {
    name: "BizSAFE STAR",
    description: "Recognises that we have conducted risk assessments for every work activity and process in compliance WSH Regulation.",
    image: "https://readdy.ai/api/search-image?query=Red%20and%20green%20bizSAFE%20STAR%20certification%20logo%20badge%20on%20white%20background%2C%20Singapore%20workplace%20safety%20program%20mark%2C%20professional%20corporate%20certification%20design&width=200&height=80&seq=cert-bizsafe-01&orientation=landscape",
  },
  {
    name: "ISO 45001",
    description: "Recognises that we are determined in improving employees' safety, reducing workplace risks and creating better and safer working conditions.",
    image: "https://readdy.ai/api/search-image?query=ISO%2045001%20health%20and%20safety%20management%20certification%20badge%20logo%20on%20white%20background%2C%20blue%20and%20red%20official%20certification%20mark%2C%20UKAS%20accreditation%20symbol%2C%20professional%20corporate%20style&width=200&height=80&seq=cert-iso45001-01&orientation=landscape",
  },
  {
    name: "EXTRON",
    description: "Authorized Extron Dealers are highly competitive on price and are unmatched in technical expertise and product support.",
    image: "https://readdy.ai/api/search-image?query=Extron%20certified%20dealer%20logo%20badge%20on%20white%20background%2C%20blue%20text%20professional%20AV%20technology%20certification%20mark%2C%20modern%20corporate%20certification%20design&width=200&height=80&seq=cert-extron-01&orientation=landscape",
  },
  {
    name: "CISCO",
    description: "Expertise with Collaboration solutions in order to deliver Voice and Unified Communications solutions.",
    image: "https://readdy.ai/api/search-image?query=Cisco%20Partner%20certification%20logo%20badge%20on%20white%20background%2C%20blue%20bridge%20symbol%20professional%20networking%20technology%20certification%20mark%2C%20modern%20corporate%20design&width=200&height=80&seq=cert-cisco-01&orientation=landscape",
  },
  {
    name: "CRESTRON",
    description: "Crestron's worldwide network of dealers provides design, installation, programming, and support services.",
    image: "https://readdy.ai/api/search-image?query=Crestron%20Authorized%20Dealer%20certification%20logo%20badge%20on%20white%20background%2C%20blue%20swirl%20symbol%20professional%20automation%20certification%20mark%2C%20modern%20corporate%20design&width=200&height=80&seq=cert-crestron-01&orientation=landscape",
  },
  {
    name: "SHURE",
    description: "Certified to design, program, deploy and manage Shure audio conferencing platforms.",
    image: "https://readdy.ai/api/search-image?query=Shure%20certification%20logo%20badge%20on%20white%20background%2C%20black%20bold%20text%20professional%20audio%20equipment%20certification%20mark%2C%20modern%20corporate%20design&width=200&height=80&seq=cert-shure-01&orientation=landscape",
  },
  {
    name: "BIAMP",
    description: "Certified to design, program, deploy and manage a plethora of Biamp audio conferencing platforms.",
    image: "https://readdy.ai/api/search-image?query=Biamp%20certification%20logo%20badge%20on%20white%20background%2C%20black%20text%20with%20red%20dot%20professional%20audio%20conferencing%20certification%20mark%2C%20modern%20corporate%20design&width=200&height=80&seq=cert-biamp-01&orientation=landscape",
  },
];

export const offices = [
  {
    city: "Singapore",
    name: "Fiber One Pte Ltd",
    address: "No 1 Irving Place #08-13, The Commerze @ Irving, Singapore 369546",
    phones: ["+65 6635 2366"],
    emails: ["sales.sg@fiberoneglobal.com"],
  },
  {
    city: "Chicago",
    name: "Fiber One Global",
    address: "318 W. Adams Street, Suite 1600, Chicago, IL 60606 US",
    phones: ["+1 (312) 348-4447"],
    emails: ["sales.us@fiberoneglobal.com"],
  },
  {
    city: "Pasig City",
    name: "Fiber One Philippines",
    address: "6/F D SunTree Tower, 13 Meralco Ave., Pasig City, Philippines 1600",
    phones: ["+63 917 594-6672", "+63 976 535-9426"],
    emails: ["sales.ph@fiberoneglobal.com"],
  },
  {
    city: "Kuala Lumpur",
    name: "Fiber One Malaysia",
    address: "Level 23 -1, Premier Suite One Mont Kiara. No. 1, Jalan Kiara Mont Kiara. 50480 KL.",
    phones: ["+6013 284 8997"],
    emails: ["sales.my@fiberoneglobal.com"],
  },
];